import React, { useEffect } from "react";

function FullRedirect({ url }) {
  console.log('ran')
  useEffect(() => {
    if (url) {
      window.location.href = url;
    }
  }, []);

  return <div />;
}

export default FullRedirect;